import React, { useEffect, useState} from 'react';

//components
import { HexColorPicker } from "react-colorful";
import CloseButton from '../buttons/CloseButton';

//hooks
import useDetectClick from '../../../hooks/useDetectClick';
import useDebounce from '../../../hooks/useDebounce';



const ColourPicker = ({pickerLabel, setHasError, color, setColor, isDisabled}:{pickerLabel?: string, setHasError: (hasError:boolean)=> void, color:string, setColor:(colour: string) => void, isDisabled?: boolean}) => {
    const [showPicker, setShowPicker] = useState<boolean>(false);
    const [hexError, setHexError] = useState<string>("");
    const debounceColor = useDebounce(color, 500);

    // Validate colour with debounced value
    useEffect(() => {
        if (debounceColor && !/^[0-9A-F]{6}$/i.test(debounceColor)){
            setHexError("Invalid hex code")
            setHasError(true);
        } else{
            setHexError("")
            setHasError(false);
        }
    },[debounceColor])

    useDetectClick("colour-container", (clickedInPicker) => {
        if (!clickedInPicker){ 
            setShowPicker(false)
        }
    });

    return (
        <div className='colour-picker'>
            <label htmlFor="colour-input" className="colour-picker-label">{pickerLabel ?? "COLOUR"}</label>
            
            <div className='colour-container'>   
                <div className='colour-input-container' onClick={() => {setShowPicker(true)}} >
                    <div className='hex'>#</div>
                        
                    <input 
                        id="colour-input"
                        disabled={isDisabled}
                        type='text' 
                        value={color} 
                        maxLength={6} 
                        onChange={(e) => {setColor(e.target.value); setShowPicker(false)}}
                    />
                        
                    <div className='colour-rep' style={{backgroundColor: `#${color}`}} />     
                </div>

                {hexError && 
                    <span className='error-hex'>{hexError}</span>
                }
                        
                {showPicker && !isDisabled &&
                    <div className='picker-container-wrapper'>
                        <div className='picker-container'>
                            <CloseButton ariaLabel={'Close Picker'} onButtonClick={() => setShowPicker(false)} />
                    
                            <HexColorPicker color={color} onChange={(color: string) => setColor(color.replace('#', ''))} />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default ColourPicker;